import { render, staticRenderFns } from "./NutrientContentTip.vue?vue&type=template&id=52c2990d&scoped=true&"
import script from "./NutrientContentTip.vue?vue&type=script&lang=js&"
export * from "./NutrientContentTip.vue?vue&type=script&lang=js&"
import style0 from "./NutrientContentTip.vue?vue&type=style&index=0&id=52c2990d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2990d",
  null
  
)

export default component.exports